import React, { Component } from 'react';
import { array, object, oneOfType } from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { numberWithCommas } from 'ps-components/lib/formatters';
import StatisticsNugget from 'ps-components/StatisticsNugget/StatisticsNugget';
import DataNugget from 'ps-components/StatisticsNugget/DataNugget/DataNugget';
import { actions as jobMatchingActions } from '../Common/JobState';
import { actions as organizationStatisticsActions } from '../Common/OrganizationStatisticsState';
import { actions as surveyActivityActions } from '../Common/SurveyActivityState';
import classnames from 'classnames';

import './StatisticsBar.scss';

const JOBS_URL = '/iframe/merit/hris/job/jobs';
const STRUCTURES_URL = '/iframe/merit/hris/structures/structures';

class StatisticsBar extends Component {
  static propTypes = {
    children: oneOfType([array, object])
  };

  componentDidMount() {
    const { dispatch } = this.props;

    organizationStatisticsActions.getOrganizationStatistics(dispatch);
    surveyActivityActions.getSurveyActivity(dispatch);
    jobMatchingActions.getJobMatches(dispatch);
  }

  render() {
    const { activeSurveys, history, surveyCount, companyCount, inactiveSurveys, orgCounts } = this.props;
    const emptyNuggetLabel = '';
    const emptyNuggetValue = '-';

    return (
      <div className="db-statistics__bar-container">
        <div className="db-statistics__bar">
          <StatisticsNugget title="Jobs Matched">
            <DataNugget
              label="Survey"
              labelTooltip="Survey jobs matched to Company jobs"
              value={surveyCount ? numberWithCommas(surveyCount) : emptyNuggetValue}
            />
            <DataNugget
              label="Company"
              labelTooltip="Company jobs matched to Survey jobs"
              value={companyCount ? numberWithCommas(companyCount) : emptyNuggetValue}
            />
          </StatisticsNugget>
          <StatisticsNugget title="Survey Activity">
            <DataNugget label="Active" value={activeSurveys ? activeSurveys : emptyNuggetValue} />
            <DataNugget label="Inactive" value={inactiveSurveys ? inactiveSurveys : emptyNuggetValue} />
          </StatisticsNugget>
          <StatisticsNugget
            title="Jobs"
            titleClick={() => {
              history.push(JOBS_URL);
            }}
          >
            <DataNugget
              label={emptyNuggetLabel}
              value={orgCounts?.jobs ? numberWithCommas(orgCounts.jobs) : emptyNuggetValue}
            />
          </StatisticsNugget>
          <StatisticsNugget
            title="Salary Ranges"
            titleClick={() => {
              history.push(STRUCTURES_URL);
            }}
          >
            <DataNugget
              label={emptyNuggetLabel}
              value={orgCounts?.salaryRanges ? numberWithCommas(orgCounts.salaryRanges) : emptyNuggetValue}
            />
          </StatisticsNugget>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ landingDashboard }) => ({
  activeSurveys: landingDashboard.SurveyActivity.data.activeSurveys,
  companyCount: landingDashboard.JobMatching.jobMatching.companyCount,
  inactiveSurveys: landingDashboard.SurveyActivity.data.inactiveSurveys,
  orgCounts: landingDashboard.OrganizationStatistics.data.statistics.orgCounts,
  surveyCount: landingDashboard.JobMatching.jobMatching.surveyCount
});

export default withRouter(connect(mapStateToProps)(StatisticsBar));
